<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M7.75 19.25H16.25C17.3546 19.25 18.25 18.3546 18.25 17.25V9L14 4.75H7.75C6.64543 4.75 5.75 5.64543 5.75 6.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M18 9.25H13.75V5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.75 15.25H14.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.75 12.25H14.25" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
